import Stars from 'atomic/stars';
import classNames from 'classnames';
import flectionNumeral from 'helpers/number';
import OpinionsInterface from 'interfaces/opinions.interface';
import React, { ReactNode } from 'react';
import Link from 'atomic/link';
import { generateAddOpinionLink } from 'helpers/opinion-url-manager';

import './rating.scss';

interface OpinionsProps {
    className?: string;
    size?: 'sm' | 'md' | 'lg';
    opinions: Pick<OpinionsInterface, 'average' | 'count' | 'url'> | null;
    isAddOpinion?: boolean;
}

const Rating: React.FC<OpinionsProps> = ({
    opinions,
    className,
    size = 'md',
    isAddOpinion = false
}) => {
    const renderRatingCount = (): ReactNode => {
        if (!opinions) {
            return null;
        }

        if (!opinions.count && isAddOpinion && opinions.url) {
            return (
                <Link
                    href={generateAddOpinionLink(opinions.url)}
                    className="rating__add-opinion"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                >
                    Dodaj opinie
                </Link>
            );
        }

        if (opinions.count) {
            return (
                <a className={classNames({
                    'rating-count': true,
                    'brackets': opinions.count !== 0
                })}
                href={opinions.url}
                rel="noopener noreferrer"
                target="_blank"
                >
                    {flectionNumeral(opinions.count, ['opinia', 'opinie', 'opinii'])}
                </a>
            );
        }

        return (
            <span className="rating-count">Brak opinii</span>
        );
    };

    return (
        opinions && (
            <div
                className={classNames({
                    rating: true,
                    [`${className}`]: !!className
                })}
            >
                <Stars
                    className="rating-stars"
                    width={opinions.average}
                    inline={true}
                    size={size}
                />
                {opinions.average > 0 && (
                    <span className="rating-average">
                        {opinions.average.toFixed(1).replace('.', ',')}
                    </span>
                )}
                {renderRatingCount()}
            </div>
        )
    );
};

export default Rating;
